import { render, staticRenderFns } from "./RoleUpdateForm.vue?vue&type=template&id=80f9c09a&scoped=true&"
import script from "./RoleUpdateForm.vue?vue&type=script&lang=js&"
export * from "./RoleUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f9c09a",
  null
  
)

export default component.exports